import { Table } from "antd";
import { useEffect, useState } from "react";
const TaxCollectionDetailTable = ({
  taxDetailsOfPropertyBasedOnYear,
  setSelectedRow,
  propertyData,
  isOld,
}) => {
  const columns = [
    {
      title: "PIN",
      dataIndex: "pin",
      render: (pin) => (pin ? pin : "---"),
    },
    {
      title: "ATV",
      dataIndex: "annualTaxableValue",
      render: (annualTax) => annualTax?.toLocaleString(),
    },
    {
      title: "Total Tax (5% of ATV)",
      dataIndex: "annualTax",
      render: (annualTax) => annualTax?.toLocaleString(),
    },
    {
      title: "Total Payable",
      dataIndex: "totalPayable",
      render: (totalPayable) => totalPayable?.toLocaleString(),
    },
    {
      title: "Last Created",
      dataIndex: "lastCreatedAt",
      render: (lastCreatedAt) =>
        lastCreatedAt
          ? new Date(lastCreatedAt)
              ?.toLocaleDateString("en-IN", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })
              .replace(/\s+/g, "-")
          : "-",
    },
    {
      title: "Actions",
      dataIndex: "enabledGenerate",
      render: (enabledGenerate, record) => {
        const color = enabledGenerate ? "#2196F3" : "#000000";
        const pointerEvents = enabledGenerate ? "all" : "none";
        const text=enabledGenerate?"Generate Challan":"-"
        return (
          <span
            style={{
              color: color,
              pointerEvents: pointerEvents,
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => setSelectedRow(record)}
          >
            {text}
          </span>
        );
      },
    },
  ];
  const [tableColumns, setTableColumns] = useState(columns);
  useEffect(() => {
    if (isOld) {
      const newColumns = [
        {
          title: "PIN",
          dataIndex: "pin",
          render: (pin) => (pin ? pin : "---"),
        },
        {
          title: "ATV",
          dataIndex: "annualTaxableValue",
          render: (annualTax) => annualTax?.toLocaleString(),
        },
        {
          title: "Total Tax (5% of ATV)",
          dataIndex: "annualTax",
          render: (annualTax) => annualTax?.toLocaleString(),
        },
        {
          title: "Total Payable",
          dataIndex: "totalPayable",
          render: (totalPayable) => totalPayable?.toLocaleString(),
        },
        {
          title: "Type",
          dataIndex: "type",
          render: (type) => type.toUpperCase(),
        },
        {
          title: "Last Created",
          dataIndex: "lastCreatedAt",
          render: (lastCreatedAt) =>
            lastCreatedAt
              ? new Date(lastCreatedAt)
                  ?.toLocaleDateString("en-IN", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })
                  .replace(/\s+/g, "-")
              : "-",
        },
      ];
      setTableColumns(newColumns);
    } else {
      setTableColumns(columns);
    }
  }, [isOld]);
  return (
    <Table
      rowClassName="table-row-cursor-pointer"
      columns={tableColumns}
      dataSource={taxDetailsOfPropertyBasedOnYear?.data}
      pagination={false}
      loading={taxDetailsOfPropertyBasedOnYear?.loading}
      scroll={{ x: "max-content" }}
    />
  );
};
export default TaxCollectionDetailTable;
